// extracted by mini-css-extract-plugin
export var avatar = "_s4-3";
export var avatarContainer = "_s4-2";
export var avatarSpacer = "_s4-5";
export var avatarSpacerContainer = "_s4-4";
export var avatarStackContainer = "_s4-1";
export var bubble = "_s4-0";
export var remainderBubble = "_s4-6";